import { jsx as _jsx } from "react/jsx-runtime";
function QuickButtonComponent({ button, onQuickButtonClicked }) {
    return (_jsx("button", { className: "\n          transform-all border-primary-600 hover:bg-primary-600 active:border-primary-300 active:bg-primary-300 rounded-xl border-2 bg-white\n          py-1 px-2 font-bold text-black transition-all duration-150\n          ease-in-out hover:text-white\n          ", onClick: (event) => onQuickButtonClicked(event, button), children: button.text }));
}
export default QuickButtonComponent;
